module.exports = __webpack_public_path__ + "static/media/dashboard.afffda7c.svg";